import { render, staticRenderFns } from "./hqglBenefitsProcureFee.vue?vue&type=template&id=52cc0af4&scoped=true&"
import script from "./hqglBenefitsProcureFee.vue?vue&type=script&lang=js&"
export * from "./hqglBenefitsProcureFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc0af4",
  null
  
)

export default component.exports